import { useState } from 'react';

export default function Contact() {
  const [submitted, setSubmitted] = useState(false);
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setFormError('');
    const form = e.currentTarget as HTMLFormElement;
    const formData = new FormData(form);
    const honeypot = (formData.get('website_alt') as string || '').trim();
    if (honeypot) {
      setSubmitted(true);
      return;
    }
    formData.delete('website_alt');

    try {
      const response = await fetch('https://readdy.ai/api/form/d9mb5c4it35ii3jdlh20', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }
      const serverMsg = parsed?.meta?.message || parsed?.message || '';

      if (response.ok && parsed?.code === 'OK') {
        setSubmitted(true);
      } else {
        if (serverMsg && serverMsg.includes('spam')) {
          setSubmitted(true);
        } else {
          setFormError(serverMsg || '提交失败，请稍后重试');
        }
      }
    } catch {
      setFormError('网络错误，请检查连接后重试');
    }
  };

  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-3">
            联系我们
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            有任何问题、建议或合作意向，欢迎给我们留言
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 mb-8">
          <div className="bg-background-50 rounded-xl p-5 border border-background-200/60 text-center">
            <div className="w-10 h-10 flex items-center justify-center mx-auto rounded-full bg-primary-100 text-primary-500 mb-3">
              <i className="ri-mail-line text-lg"></i>
            </div>
            <h3 className="text-sm font-heading font-semibold text-foreground-800 mb-1">邮箱联系</h3>
            <p className="text-xs text-foreground-500">contact@fuqicinema.com</p>
          </div>
          <div className="bg-background-50 rounded-xl p-5 border border-background-200/60 text-center">
            <div className="w-10 h-10 flex items-center justify-center mx-auto rounded-full bg-accent-100 text-accent-500 mb-3">
              <i className="ri-wechat-line text-lg"></i>
            </div>
            <h3 className="text-sm font-heading font-semibold text-foreground-800 mb-1">微信关注</h3>
            <p className="text-xs text-foreground-500">公众号：夫妻影院</p>
          </div>
          <div className="bg-background-50 rounded-xl p-5 border border-background-200/60 text-center">
            <div className="w-10 h-10 flex items-center justify-center mx-auto rounded-full bg-secondary-100 text-secondary-500 mb-3">
              <i className="ri-question-answer-line text-lg"></i>
            </div>
            <h3 className="text-sm font-heading font-semibold text-foreground-800 mb-1">在线反馈</h3>
            <p className="text-xs text-foreground-500">填写表单，24小时内回复</p>
          </div>
        </div>

        <div className="bg-background-50 rounded-2xl border border-background-200/60 p-6 md:p-8 max-w-xl mx-auto">
          {submitted ? (
            <div className="text-center py-8">
              <div className="w-14 h-14 flex items-center justify-center mx-auto rounded-full bg-primary-100 text-primary-500 mb-4">
                <i className="ri-check-line text-2xl"></i>
              </div>
              <h3 className="text-base font-heading font-semibold text-foreground-800 mb-1">留言已收到</h3>
              <p className="text-sm text-foreground-500">感谢你的反馈，我们会尽快处理并回复。</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} data-readdy-form="" className="space-y-4">
              <div>
                <label className="block text-xs font-medium text-foreground-700 mb-1.5">昵称</label>
                <input
                  type="text"
                  name="name"
                  required
                  className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-300 bg-white focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-colors"
                  placeholder="请输入昵称"
                />
              </div>
              <div>
                <label className="block text-xs font-medium text-foreground-700 mb-1.5">邮箱</label>
                <input
                  type="email"
                  name="email"
                  required
                  className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-300 bg-white focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-colors"
                  placeholder="请输入邮箱地址"
                />
              </div>
              <div>
                <label className="block text-xs font-medium text-foreground-700 mb-1.5">留言内容</label>
                <textarea
                  name="message"
                  required
                  maxLength={500}
                  rows={4}
                  className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-300 bg-white focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-colors resize-none"
                  placeholder="请输入留言内容（500字以内）"
                ></textarea>
              </div>
              <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
              {formError && (
                <p className="text-sm text-red-500 text-center">{formError}</p>
              )}
              <button
                type="submit"
                className="w-full px-6 py-2.5 bg-primary-500 text-white text-sm font-medium rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                提交留言
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
}